module.exports = __webpack_public_path__ + "static/media/sound-black-shadow-off.0aec754f.png";